import epubVersions from "astrid-firestore/src/api/articles/constants/epubVersions";

export default function useEpubVersionOptions() {
	return Object.keys(epubVersions).map((version) => ({ key: version, value: version, text: version }));
}
